import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { LoadingSpinner } from '../ui/LoadingSpinner'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, mfaPending } = useAuth()
  const location = useLocation()
  const params = useParams<{ slug?: string }>()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" variant="icon" />
      </div>
    )
  }

  if (!isAuthenticated) {
    const loginPath = params.slug ? `/o/${params.slug}/login` : '/login'
    return <Navigate to={loginPath} state={{ from: location }} replace />
  }

  if (mfaPending) {
    return <Navigate to="/login/mfa" state={{ from: location }} replace />
  }

  return <>{children}</>
}
